import type { Page } from '../../types';

const questions = [
  {
    name: 'planned-secondments-next-12-months',
    title:
      'Do you have an aspiration or planned number of inward or outward secondments in the next 12 months?',
  },
  {
    name: 'changes-to-secondments-approach',
    title: 'Do you envisage any changes in your current approach to secondments?',
  },
  {
    name: 'capability-gaps',
    title: 'Are there particular capability gaps you plan to fill through secondments?',
  },
  {
    name: 'sectors-or-organisations',
    title:
      'Are there particular sectors or organisations that you plan to engage with on secondments?',
  },
  {
    name: 'secondments-barriers',
    title:
      'Are you encountering any particular barriers or challenges in setting up or maintaining secondments?',
  },
  {
    name: 'secondment-schemes',
    title:
      'Does your department currently conduct, take part in or know of any Secondment Schemes/Initiatives?',
    hint: "If yes, provide details of the name of the schemes, the scheme's organiser/PoC (if you hold this) and the scheme's purpose.",
  },
];

const furtherQuestions: Page[] = [
  {
    pageType: 'question',
    title: 'Further Questions',
    name: 'further-questions',
    questions: questions.map(({ name, title, hint }) => ({
      questionType: 'textarea',
      name,
      title,
      hint,
      textRows: 8,
      hideOptionalLabel: true,
      rules: { required: true },
    })),
  },
];

export default furtherQuestions;
